/**
 * @generated SignedSource<<a5d21112c6283e39b4e344c6c47bb126>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanel_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_item" | "PdpRespPricingGuidance_item" | "PdpSharedDescriptionAbout_item" | "pricingGuidanceHelpers_item">;
  readonly " $fragmentType": "PdpRespAboutItemPanel_item";
};
export type PdpRespAboutItemPanel_item$key = {
  readonly " $data"?: PdpRespAboutItemPanel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanel_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanel_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAbout_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_item"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPricingGuidance_item"
        }
      ]
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "pricingGuidanceHelpers_item",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PricingGuidance",
          "kind": "LinkedField",
          "name": "pricingGuidance",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pricingGuidanceType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceRange",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "priceBookName",
              "variableName": "priceBookName"
            },
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            }
          ],
          "concreteType": "ItemDisplayPriceType",
          "kind": "LinkedField",
          "name": "displayPrice",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": [
        {
          "kind": "RootArgument",
          "name": "isTrade"
        },
        {
          "kind": "RootArgument",
          "name": "priceBookName"
        },
        {
          "kind": "RootArgument",
          "name": "userCountryCode"
        },
        {
          "kind": "RootArgument",
          "name": "userId"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "c1c1b8f119bcef4a8cbc30e2f33232a1";

export default node;
